import { render, staticRenderFns } from "./AntiDogUnit.vue?vue&type=template&id=1c765c36&"
import script from "./AntiDogUnit.vue?vue&type=script&lang=js&"
export * from "./AntiDogUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports